import styled from 'styled-components';
import { Tbody } from '@pages/Products/components/AddEquipmentModal/components/tables.styles';

export const Button = styled.button`
  color: #1a1b1c;
  border: none;
  background: transparent;
  cursor: pointer;
  z-index: 999;
  :disabled {
    opacity: 0.3;
    cursor: auto;
  }
`;
export const LabelQuantity = styled.div`
  margin-left: 15px;
  margin-right: 15px;
  width: 25px;
  text-align: center;
`;
export const TbodyBigger = styled(Tbody)`
  max-height: 500px;
`;
export const BlueButton = styled.div`
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  /* identical to box height */

  /* beam-colors/beam-accent */
  color: #1371fe;
`;
